import styled from 'styled-components';
import { Card as AntdCard } from 'antd';

const { Meta: AntdMeta } = AntdCard;

export const Meta = styled(AntdMeta)`
  font-size: 2rem;
`;
